import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AUTH_KEYS, NS } from '../../i18n/constants/keys';
import logoBlackText from '../../assets/images/logos/white-bg-logo-hiacuity.png';
import LogoWhite from '../../assets/images/logos/white-bg-logo-hiacuity.png';
import { AnimatedChangePassword } from '../../assets/svgs/ChangePasswordAnimate';
import { Button } from '../../ui';
import { getImageSrc } from '../../utils/helpers/image-utils';
import { RootState } from '../../utils/redux_store/store';
import { AuthenticationUiLayout } from './AuthenticationUILayout';
import { CompanyLogoBadge } from './CompanyLogoBadge';
export const TermsConditions = () => {
  const history = useHistory();
  const { t } = useTranslation(NS.auth);

  const handleSubmit = () => {
    history.push(`/identity-check/${localStorage.getItem('token')}`);
  };

  const companyLogo = useSelector((state: RootState) => state.logo.companyLogo);
  const companyName = useSelector((state: RootState) => state.logo.companyName);

  return (
    <AuthenticationUiLayout leftContent={<AnimatedChangePassword />}>
      <div className='flex items-start flex-col w-full gap-6 pt-10'>
        <CompanyLogoBadge
            logoUrl={companyLogo}
            companyName={companyName}
            altText='HiAcuity Logo'
        />
        <h1 className='text-2xl md:text-4xl font-medium'>
          { t(AUTH_KEYS.terms.title) }
        </h1>
      </div>
      <form
          className='flex flex-col space-y-4 mt-10 pb-20'
          onSubmit={handleSubmit}
          data-testid='change-password-form'
      >
        <p>
          { t(AUTH_KEYS.terms.para1) }
        </p>
        <p>
          <br />
          { t(AUTH_KEYS.terms.para2) }
        </p>
        <p>
          <br />
          { t(AUTH_KEYS.terms.para3) }
          <br />
          <br />
        </p>
        <Button
            onClick={() => {}}
            label={t(AUTH_KEYS.terms.consentContinue)}
            variant='primary'
            type='submit'
        />
      </form>
    </AuthenticationUiLayout>
  );
};
